
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { message, Modal } from 'antd';
import CustomBadge from 'components/CustomBadge';

// 以 Job 为粒度锁定进行中的查询，避免重复点击产生重复的远程自动化请求。
const spearMilestoneRequestJobIds = new Set();

// EPI Application 顶部按钮：查询、保存后刷新当前详情区，不再额外开启抽屉。
export function showSpearMilestones({ pageComponent } = {}) {
  const jobId = pageComponent?.props?.jobId;
  if (!jobId) {
    message.warning('This EPI application has not been loaded.');
    return;
  }

  const planNumber = (pageComponent?.state?.jobData?.PptLpps || '').trim();
  if (!planNumber) {
    message.warning('Please enter a Plan No. before retrieving SPEAR milestones.');
    return;
  }

  if (spearMilestoneRequestJobIds.has(jobId)) {
    message.info('SPEAR milestones are already being retrieved. Please wait.');
    return;
  }

  spearMilestoneRequestJobIds.add(jobId);
  const messageKey = `spear-milestones-${jobId}`;
  // 提示持续到远程或本地查询结束，避免用户误以为按钮没有响应。
  message.info({
    key: messageKey,
    duration: 0,
    content: 'Retrieving SPEAR milestones. Please wait...'
  });

  httpClient
    .get('/Business/EpiSpear/Job/' + jobId + '/Milestones')
    .then(({ data }) => {
      if (data.result) {
        globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
        message.success({ key: messageKey, content: 'SPEAR milestones have been updated.', duration: 3 });
      } else {
        // SPEAR / HandlerAPI 不可用属于本功能的可恢复错误，不跳转全局错误页。
        // 后端已写入本次失败状态，刷新详情以显示“保留的旧结果 + 失败原因”。
        globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
        message.error({
          key: messageKey,
          content: data.message || 'Unable to retrieve SPEAR milestones. Please try again later.',
          duration: 5
        });
      }
    })
    .catch((error) => {
      // 网络断开或 API 未启动时同样保留在当前 Job 页面，已有 Milestones 不受影响。
      message.error({
        key: messageKey,
        content: error?.response?.data?.message || 'Unable to retrieve SPEAR milestones. Please try again later.',
        duration: 5
      });
    })
    .finally(() => {
      // 无论成功或失败均释放锁，方便用户稍后再次查询。
      spearMilestoneRequestJobIds.delete(jobId);
    });
}

//显示label选择的弹出框
export function showLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageLabelShow: true });
  sectionComponent.child.current?.labelDiv.current?.getLabelList(parameter.key);
}

//各种过滤器刷新Job列表
export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    sectionComponent.child.current?.setState({ loaded: false });
    setTimeout(() => {
      let searchParameter = { ...sectionComponent.state.searchParameter };
      searchParameter.module = pageComponent.state.searchParameter.module;
      sectionComponent.setState({ searchParameter });
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

//显示label过滤器的弹出框
export function showFilterByLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let that = this;
  httpClient
    .get('/Admin/Label/GetGroupList?module=' + sectionComponent.state.searchParameter.module)
    .then(({ data }) => {
      if (data.result) {
        let labelGroup = [];
        data.data.map((item, i) => {
          let labels = [];
          item.DataList.map((label, i) => {
            labels.push({
              label: <CustomBadge text={label.Name} backgroundColor={label.BackgroundColor} verticalAlign="top" />,
              value: label.LabelId
            })
          })
          labelGroup.push({ Name: item.Name, DataList: labels });
        })
        pageComponent.setState({ labelGroup: labelGroup, filterByLabeShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, that.props.pageComponent);
    });
}

//Job列表下载Excel
export function exportToExcel({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.module = pageComponent.state.searchParameter.module;
  globalFunction.download({ url: '/Business/Job/ExportToExcel?' + (new URLSearchParams(searchParameter).toString()), data: null, filename: 'Jobs.xlsx' });
}

//Job列表刷新
export function refreshJobPaging({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter.module = pageComponent.state.searchParameter.module;
  sectionComponent.setState({ searchParameter });
  sectionComponent.getSectionDataByDefault();

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = true;
    sectionComponent.setState(sectionComponent.state.section);
  }, 100);

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = false;
    sectionComponent.setState(sectionComponent.state.section);
  }, 1100);
}

//显示CalcLevy的弹出框
export function showCalcLevy({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Business/Job/Access/' + pageComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ jobData: data.data, calcLevyShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//显示StageInfo的弹出框
export function showStageInfo({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  console.log(parameter);
  httpClient
    .get('/Business/Job/GetStageList/' + pageComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ stageList: data.data, stageInfoShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//显示LinkInfo的弹出框
export function showLinkInfo({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Business/Job/GetLinkIdList?linkId=' + encodeURIComponent(parameter.LinkId))
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ linkIdList: data.data, linkInfoShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//显示GenerateVBA的弹出框
export function showGenerateVBA({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ generateVBAShow: true });
  pageComponent.generateVBA.current?.setState({ updatePermitApplicationDate: pageComponent.state.jobData.PermitApplicationDate === null });
}

//显示VIC30A的弹出框
export function showVIC30A({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ vic30aShow: true });
  httpClient
    .get('/Business/VIC30A?jobId=' + pageComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.vic30a.current?.setState({ checkAll: false });
        pageComponent.vic30a.current?.formRef.current?.setFieldsValue(data.data);
        pageComponent.vic30a.current?.getVic30aTemplate();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//显示CopyJob的弹出框
export function showCopyJob({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ copyJobShow: true });
  pageComponent.copyJob?.current?.getJobDocumentData();
  pageComponent.copyJob?.current?.getDocumentTypeData();
  pageComponent.copyJob?.current?.getModuleData();
  pageComponent.copyJob?.current?.setState({ selectedRowKeys: [] });
}


export function getJobComponentDataSourceGroupRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  if (componentDataSource['AllInsuranceProvider'] === undefined) {
    componentDataSource['AllInsuranceProvider'] = componentDataSource['InsuranceProvider'];
  } else {
    componentDataSource['InsuranceProvider'] = componentDataSource['AllInsuranceProvider'];
  }
  if (componentDataSource['AllWorkDescription'] === undefined) {
    componentDataSource['AllWorkDescription'] = componentDataSource['WorkDescription'];
  } else {
    componentDataSource['WorkDescription'] = componentDataSource['AllWorkDescription'];
  }
  let currentJobTypeId = sectionComponent.customForm.current?.formRef?.current?.getFieldValue('JobTypeId');
  if (currentJobTypeId) {
    componentDataSource['WorkDescription'] = (componentDataSource['AllWorkDescription'] || []).filter(
      item => !Array.isArray(item.data?.JobTypeIdList)
        || item.data.JobTypeIdList.length === 0
        || item.data.JobTypeIdList.includes(currentJobTypeId)
    );
  }
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

export function jobTypeChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  if (componentDataSource['AllWorkDescription'] === undefined) {
    componentDataSource['AllWorkDescription'] = componentDataSource['WorkDescription'];
  }
  let allOptions = componentDataSource['AllWorkDescription'] || [];
  let filtered = parameter
    ? allOptions.filter(item => !Array.isArray(item.data?.JobTypeIdList)
        || item.data.JobTypeIdList.length === 0
        || item.data.JobTypeIdList.includes(parameter))
    : allOptions;
  componentDataSource['WorkDescription'] = filtered;
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

export function insuranceProviderChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource['InsuranceProvider'] = parameter
    ? sectionComponent.customForm.current?.state.componentDataSource['AllInsuranceProvider'].filter((item) => item.label.toLowerCase().indexOf(parameter.toLowerCase()) >= 0)
    : sectionComponent.customForm.current?.state.componentDataSource['AllInsuranceProvider'];
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

//显示JobDataTemplate的弹出框
export function showJobDataTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ jobDataTemplateShow: true });
  pageComponent.jobDataTemplate?.current?.getJobDataTemplateData();
}

export function deleteJobLink({ e, sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  e.preventDefault();
  Modal.confirm({
    title: 'Confirm',
    content: 'Unlink this job?',
    transitionName: "",
    maskTransitionName: "",
    onOk: () => {
      httpClient
        .put('/Business/Job/DeleteJobLink', parameter)
        .then(({ data }) => {
          if (data.result) {
            globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    },
  });
}

export function workDescriptionSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
}

//显示TimeCategoryTracking的弹出框
export function showTimeCategoryTracking({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Business/Job/GetTimeCategoryTracking/' + pageComponent.props.jobId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ timeCategoryTrackingShow: true });
        let totalDays = data.data.TotalDaysByCategoryList?.reduce((sum, item) => sum + item.Days, 0);
        if (totalDays === undefined) {
          totalDays = 0
        };
        pageComponent.timeCategoryTracking.current.setState({ data: data.data, totalDays });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

// 打开当前 Job 的 Inspection Type / Paid 设置
export function showInspectionCategoryPaid({ pageComponent } = {}) {
  pageComponent.inspectionCategoryPaid.current?.open();
}
